/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Box from '@mui/material/Box';
import image1 from './musc_guide_image1.svg';
import image2 from './musc_guide_image2.svg';
import image3 from './musc_guide_image3.svg';
import styles from './MuscQuickStartGuide.module.scss';

export default function MuscQuickStartGuideText() {
  return (
    <div className={styles.muscTextContainer} data-testid="musc-guide">
      <p className={styles.muscTextHeading}>MedPearl Tip Sheet</p>
      <Box component="img" src={image1} alt="MedPearl Image" my={2} />
      <p className={styles.muscTextHeading}>What is MedPearl?</p>
      <p>
        MedPearl is a <b>clinical intelligence decision platform</b> that enables clinicians to optimize their care of
        patients
        <b> at the point of care </b>. Knowledge is not embedded in the electronic health record (EHR). Current tools
        provide the "what to know”, and not the "what to do” like MedPearl. For more information, checkout the{' '}
        <a target="_blank" rel="noopener noreferrer" href="https://musc.sharepoint.com/sites/HI-MedPearl">
          MedPearl Intranet Page.
        </a>
      </p>
      <p className={styles.muscTextHeading}>How do I access MedPearl in Epic?</p>
      <Box component="img" src={image2} alt="Epic Access Steps" my={2} />
      <p>
        <strong>Step 1: </strong> Open patient records first and search “MedPearl” at the top of your Epic screen.
      </p>
      <Box component="img" src={image3} alt="MedPearl Image-1" my={1} />
      <p>
        <strong>Step 2: </strong> From your Epic menu tool bar below Search, click on 'More', scroll down to 'MedPearl',
        click on 'Move Up' to move 'MedPearl' icon to the front of your tool bar for easier access.
      </p>
    </div>
  );
}
